module.exports = __webpack_public_path__ + "img/African Bank.84dd1d3b.svg";